import { render, staticRenderFns } from "./productVolumeDetail.vue?vue&type=template&id=22978c37&scoped=true&"
import script from "./productVolumeDetail.vue?vue&type=script&lang=js&"
export * from "./productVolumeDetail.vue?vue&type=script&lang=js&"
import style0 from "./productVolumeDetail.vue?vue&type=style&index=0&id=22978c37&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22978c37",
  null
  
)

export default component.exports